// BETA-53's third wizard screen, shown once a connection has just been
// created (never on an edit): confirm the historian setting for the tags
// this device brought in, in the same flow instead of a trip to Tags
// afterward. `createOrdinaryTag` already turns history on (mode "on
// change") for every NEW tag at creation time, so this step is usually
// reinforcing a default rather than changing one — but it is also what
// covers a tag path the connector reused instead of creating, and it is the
// one place the operator can pick interval sampling or turn history off for
// this device.
//
// Mode 0 (on change) needs no interval at all, which is why it is the
// default: never invent a fast polling interval for hardware that is
// already slow and easily overloaded (a Solis inverter, for instance).
import React, { useState } from "react";

import NudgeNumber from "../../../components/NudgeNumber";
import Select from "../../../components/Select";

const MODE_OPTIONS = [
  { value: "0", label: "On change" },
  { value: "1", label: "Interval" },
  { value: "2", label: "On change + interval" },
];

export default function AddDeviceHistorianStep({ tagCount, busy, onSkip, onApply }) {
  const [enabled, setEnabled] = useState(true);
  const [mode, setMode] = useState("0");
  const [intervalMs, setIntervalMs] = useState(5000);

  const submit = () => {
    if (!enabled) {
      onApply(null);
      return;
    }
    const historianMode = Number(mode);
    onApply({
      enabled: true,
      historian_mode: historianMode,
      ...(historianMode !== 0 ? { historian_interval_ms: intervalMs } : {}),
    });
  };

  return (
    <div className="gwCardSection">
      <div className="gwSectionTitle">History</div>
      <div className="gwCardSectionBody">
        <div className="gwHint">
          {tagCount} {tagCount === 1 ? "tag" : "tags"} from this device. Slow, temperamental hardware is
          happiest with "on change" — no interval to tune, and history never polls faster than the device
          itself reports.
        </div>
        <label className="gwField" style={{ flexDirection: "row", alignItems: "center", gap: 8 }}>
          <input
            type="checkbox"
            checked={enabled}
            disabled={Boolean(busy)}
            onChange={(event) => setEnabled(event.target.checked)}
          />
          Enable history for these tags
        </label>
        {enabled ? (
          <div className="gwConnectionFields">
            <div className="gwField">
              <label className="gwLabel">Mode</label>
              <Select value={mode} options={MODE_OPTIONS} onChange={setMode} disabled={Boolean(busy)} />
            </div>
            {mode !== "0" ? (
              <div className="gwField">
                <label className="gwLabel">Interval (ms)</label>
                <NudgeNumber
                  value={intervalMs}
                  onChange={setIntervalMs}
                  min={500}
                  max={3600000}
                  disabled={Boolean(busy)}
                  aria-label="Historian interval (ms)"
                />
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
      <div className="gwModalFooter" style={{ justifyContent: "flex-end" }}>
        <button type="button" className="gwGhostBtn" disabled={Boolean(busy)} onClick={onSkip}>Skip</button>
        <button type="button" className="gwPrimaryBtn" disabled={Boolean(busy)} onClick={submit}>
          {busy ? "Applying…" : "Done"}
        </button>
      </div>
    </div>
  );
}
